import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

// Fix pour les icônes Leaflet par défaut
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Icônes personnalisées pour chaque type de marqueur
const createCustomIcon = (color, icon) => {
  return L.divIcon({
    className: 'custom-marker',
    html: `<div class="custom-marker" style="background-color: ${color}">${icon}</div>`,
    iconSize: [36, 36],
    iconAnchor: [18, 36],
    popupAnchor: [0, -36]
  });
};

export const icons = {
  chantier: createCustomIcon('#f59e0b', '🏗️'),
  membre: createCustomIcon('#3b82f6', '👤'),
  dommage: createCustomIcon('#ef4444', '⚠️'),
  travaux: createCustomIcon('#8b5cf6', '🔧'),
  cooper: createCustomIcon('#10b981', '🤝')
};

// Composant pour auto-centrer la carte
export const AutoCenter = ({ center, zoom }) => {
  const map = useMap();
  
  useEffect(() => {
    if (center) {
      map.flyTo(center, zoom || 6, { duration: 1.2 });
    }
  }, [center, zoom, map]);
  
  return null;
};

// V36.38 — Coordonnées + zoom optimisés pour chaque territoire DOM-TOM + métropole
export const TERRITOIRE_PRESETS = [
  { key: 'all',         label: 'Tout',          center: [20.0, -30.0], zoom: 3,  emoji: '🌍' },
  { key: 'metropole',   label: 'Métropole',     center: [46.6, 1.88],   zoom: 6,  emoji: '🇫🇷' },
  { key: 'guadeloupe',  label: 'Guadeloupe',    center: [16.265, -61.55], zoom: 10, emoji: '🏝️' },
  { key: 'martinique',  label: 'Martinique',    center: [14.64, -61.02], zoom: 11, emoji: '🏝️' },
  { key: 'guyane',      label: 'Guyane',        center: [4.0, -53.0],   zoom: 7,  emoji: '🌴' },
  { key: 'reunion',     label: 'Réunion',       center: [-21.115, 55.536], zoom: 10, emoji: '🌋' },
  { key: 'mayotte',     label: 'Mayotte',       center: [-12.83, 45.17], zoom: 11, emoji: '🐠' },
  { key: 'polynesie',   label: 'Polynésie',     center: [-17.65, -149.43], zoom: 9, emoji: '🏖️' },
  { key: 'nouvelle_caledonie', label: 'Nouvelle-Calédonie', center: [-21.30, 165.50], zoom: 8, emoji: '🪸' },
  { key: 'saint_pierre_et_miquelon', label: 'St-Pierre-et-Miquelon', center: [46.85, -56.30], zoom: 11, emoji: '⚓' },
];

